<template>
  <div class="table">
    <div
      ref="caozuo"
      style="
        display: flex;
        line-height: 40px;
        justify-content: space-between;
        margin-bottom: 10px;
      "
    >
      <div>
        <el-button size="small" plain @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <el-button size="small" @click="additional">
          <i class="el-icon-plus"></i> 新增
        </el-button>
        <!-- <el-button size="small" @click="handelrisk(1)">
          <i class="el-icon-plus"></i> 批量修改风控等级
        </el-button> -->
        <!-- <el-button size="small" @click="handelrisk(2)">
          <i class="el-icon-plus"></i> 批量修改防骚扰
        </el-button> -->
        <el-button size="small" @click="showImportDialog = true">
          <i class="el-icon-edit"></i> 批量新增企业
        </el-button>
      </div>
      <div style="display:flex;align-items:center">
        <el-form class="formes" :model="formes" :inline="true" label-width="90px">
          <el-form-item label style="margin-bottom: 0">
            <el-select v-model="call_type_id" size="small" style="width: 200px;" clearable placeholder="请选择卡种类" @change="esarchang" >
              <el-option v-for="item in callTypeList" :key="item.id" :value="item.id" :label="item.card"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <ProjectSearch ref="searchform" :fields="steps" />
        <ProjectSearch ref="searchform2" :fields="steps2" />
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :cell-style="cellStyle"
      :header-cell-style="headerCellStyle"
      @row-click="handleDetail"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="name" label="企业名称"></el-table-column>
      <el-table-column label="行业分类">
        <template slot-scope="scope">
          {{ scope.row.TypeInfo.name }}
        </template>
      </el-table-column>
      <el-table-column label="归属代理商">
        <template slot-scope="scope">
          {{ scope.row.UserInfo.name }}
        </template>
      </el-table-column>
      <el-table-column label="防骚扰平台">
        <template slot-scope="scope">
          {{
            scope.row.black_plat_is_open == 1
              ? scope.row.BlackPlatInfo.name
              : "无"
          }}
        </template>
      </el-table-column>
      <el-table-column label="风控等级">
        <template slot-scope="scope">
          {{ scope.row.StormInfo.name }}
        </template>
      </el-table-column>
      <el-table-column label="绑定授权数">
        <template slot-scope="scope">
          {{ scope.row.UserCount }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="created_at"> </el-table-column>
      <el-table-column prop="desc" label="话术"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native.stop="compile(scope.row)"
            plain
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="mini"
            plain
            @click.native.stop="deletes(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <!-- 弹出框 -->
    <el-dialog
      :title="form.id == '' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="560px"
      @close="guanbi('formRef')"
    >
      <el-form :model="form" ref="formRef" :rules="formRules">
        <el-form-item
          label="企业名称："
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-input
            style="width: 300px"
            placeholder="请输入企业名称"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          prop="mobile"
          :label-width="formLabelWidth"
        >
          <el-input
            style="width: 300px"
            placeholder="请输入手机号"
            v-model="form.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="行业分类："
          prop="type"
          :label-width="formLabelWidth"
        >
          <el-select
            style="width: 300px"
            v-model="form.type"
            placeholder="请选择行业分类"
            filterable
          >
            <el-option
              v-for="(item, index) in CompanyType"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="归属代理商："
          prop="user_id"
          :label-width="formLabelWidth"
          v-if="form.id !== ''"
        >
          <el-select
            style="width: 300px"
            v-model="form.user_id"
            placeholder="请选择代理商"
            filterable
            :disabled="!canModifyAgent"
          >
            <el-option
              v-for="(item, index) in agentData"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="防骚扰平台："
          prop="black_plat_is_open"
          :label-width="formLabelWidth"
          v-if="form.id !== ''"
        >
          <el-radio-group
            v-model="form.black_plat_is_open"
            :disabled="form.id !== ''"
          >
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label=""
          prop="black_plat_id"
          :label-width="formLabelWidth"
          v-if="form.black_plat_is_open == 1 && form.id !== ''"
        >
          <el-select
            style="width: 300px"
            v-model="form.black_plat_id"
            placeholder="请选择防骚扰平台"
            filterable
            :disabled="form.id !== ''"
          >
            <el-option
              v-for="(item, index) in BlackPlat"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="风控等级："
          prop="storm_id"
          :label-width="formLabelWidth"
          v-if="form.id !== ''"
        >
          <el-select
            style="width: 300px"
            v-model="form.storm_id"
            :disabled="form.id !== ''"
            placeholder="请选择风控等级"
            filterable
          >
            <el-option
              v-for="(item, index) in StormTemp"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="话术：" prop="desc" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="form.desc"
            maxlength="50"
            show-word-limit
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="form.remark"
            maxlength="50"
            show-word-limit
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="Recharge('formRef')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 -->

    <CompanyDetails
      v-if="modalVisible == 'detail'"
      :isShow="modalVisible == 'detail'"
      :rowData="rowData"
      @close="modalVisible = null"
    ></CompanyDetails>
    <RiskCompany
      v-if="modalVisible == 'risk'"
      :isShow="modalVisible == 'risk'"
      :rowData="changecompany"
      @close="modalVisible = null"
    ></RiskCompany>
    <AntiHarassment
      v-if="modalVisible == 'harassment'"
      :isShow="modalVisible == 'harassment'"
      :rowData="changecompany"
      @close="modalVisible = null"
    ></AntiHarassment>
    <ImportToAddCompany :showImportDialog="showImportDialog"></ImportToAddCompany>
  </div>
</template>

<script>
import { height1 } from "@/utils/height";
import {
  postACCompanyUpdateAction,
  postACCompanyAddAction,
  getACCompanyPageAction,
  getACCompanyDelAction,
} from "@/services/server/AccountInterface";
import { getDirectSonAction } from "@/services/server/publicInterface";
import AntiHarassment from "./components/AntiHarassment";
import CompanyDetails from "./components/CompanyDetails";
import RiskCompany from "./components/RiskCompany";
import { companySearchNew, companySearchNew2 } from "@/config/accountSearch";
import ProjectSearch from "@/components/ProjectSearch.vue";
import ImportToAddCompany from "./components/ImportToAddCompany";
import { getData } from "@/api/index";
export default {
  components: {
    CompanyDetails,
    RiskCompany,
    AntiHarassment,
    ProjectSearch,
    ImportToAddCompany
  },
  data() {
    var phoneRules = (rule, value, callback) => {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的电话"));
      }
    };
    return {
      select: 1,
      zhanshi: "800px",
      tableData: [],
      E_ids: [],
      rowData: [],
      changecompany: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      form: {
        id: "",
        name: "",
        user_id: "",
        type: "",
        black_plat_is_open: 1,
        black_plat_id: 1,
        storm_id: 2,
        remark: "",
        desc: "",
        mobile: "",
      },
      dialogVisible: false,
      formLabelWidth: "140px",
      agentData: [],
      CompanyType: [],
      BlackPlat: [],
      StormTemp: [],
      formRules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: phoneRules, trigger: "blur" },
        ],
        user_id: [
          { required: true, message: "请选择代理商", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择行业分类", trigger: "change" },
        ],
        black_plat_id: [
          { required: true, message: "请选择防骚扰平台", trigger: "change" },
        ],
        storm_id: [
          { required: true, message: "请选择风控等级", trigger: "change" },
        ],
        black_plat_is_open: [{ required: true, trigger: "change" }],
      },
      steps: [],
      steps2: [],
      modalVisible: "",
      showImportDialog: false,
      canModifyAgent: true,
      callTypeList:[],
      call_type_id:'',
      formes:{}
    };
  },

  async created() {
    this.getMainData();
    await Promise.all([
      this.$fetchDicByField("AgentData1"),
      this.$fetchDicByField("CompanyType"),
      this.$fetchDicByField("BlackPlat"),
      this.$fetchDicByField("StormTemp"),
      this.getDirectSon(),
    ]);
    this.steps = companySearchNew;
    this.steps2 = companySearchNew2;
    this.getCallTypeList()
  },
  mounted() {
    setTimeout(() => {
      var H = document.body.clientHeight;
      this.zhanshi = H - height1 - 8;
    }, 100);
    const that = this;
    window.onresize = () => {
      var H = document.body.clientHeight;
      that.zhanshi = H - height1 - 8;
    };
  },
  methods: {
    getCallTypeList(){
      getData("call.CallTypeController/tableListAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.callTypeList = res.data.filter((item) => item.is_card == 1);
      });
    },
    closePopDialog(){
      this.showImportDialog = false
    },
    async getDirectSon() {
      let res = await getDirectSonAction({
        page: 1,
        pagesize: 999,
      });
      this.agentData = res;
    },
    handleSelectionChange(val) {
      this.E_ids = [];
      this.changecompany = [];
      val.forEach((i) => {
        this.changecompany.push({
          id: i.id,
          StormInfo: i.StormInfo,
          name: i.name,
        });
        this.E_ids.push(i.id);
      });
    },
    handelrisk(type) {
      if (!this.changecompany.length) return this.$message.warning("请选择至少一个企业");
      if(type == 1) this.modalVisible = "risk";
      if(type == 2) this.modalVisible = "harassment";
    },
    async getoptins() {
      this.CompanyType = this.$getDicByField("CompanyType");
      this.BlackPlat = this.$getDicByField("BlackPlat");
      this.StormTemp = this.$getDicByField("StormTemp");
    },
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      let params = {
        pagesize: this.pagesize,
        page: this.currentPage,
      };
      if(this.call_type_id) params.call_type_id = this.call_type_id
      if (this.$refs.searchform.selectContent !== null) {
        params[this.$refs.searchform.selectOption] =
          this.$refs.searchform.selectContent;
      }
      if (this.$refs.searchform2.selectContent !== null) {
        params[this.$refs.searchform2.selectOption] =
          this.$refs.searchform2.selectContent;
      }
      this.getMainData(params);
    },
    // 新增
    additional() {
      this.getoptins();
      this.form = {
        id: "",
        name: "",
        user_id: "",
        type: "",
        black_plat_is_open: 1,
        black_plat_id: 1,
        storm_id: 2,
        desc: "",
        mobile: "",
        remark: "",
      };
      this.dialogVisible = true;
    },
    // 编辑
    compile(e) {
      this.canModifyAgent = e.is_direct_son === 1
      this.getoptins();
      setTimeout(() => {
        this.form = {
          id: e.id,
          name: e.name,
          user_id: e.user_id,
          type: e.type,
          black_plat_is_open: e.black_plat_is_open,
          black_plat_id: e.black_plat_id * 1,
          storm_id: e.storm_id,
          remark: e.remark,
          desc: e.desc,
          mobile: e.ManageInfo.mobile,
        };
        if (!e.black_plat_id) return (this.form.black_plat_id = 1);
      }, 50);
      this.dialogVisible = true;
    },
    // 新增确定
    Recharge(formRef) {
      this.$refs[formRef].validate(async (valid) => {
        if (valid) {
          let form = {
            name: this.form.name,
            user_id: this.form.user_id,
            type: this.form.type,
            black_plat_is_open: this.form.black_plat_is_open,
            storm_id: this.form.storm_id,
            remark: this.form.remark,
            desc: this.form.desc,
            mobile: this.form.mobile,
          };
          if (this.form.black_plat_is_open == 1) {
            form.black_plat_id = this.form.black_plat_id;
          }
          let res = null;
          if (this.form.id) {
            form.id = this.form.id;
            res = await postACCompanyUpdateAction(form);
          } else {
            res = await postACCompanyAddAction(form);
          }
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message({ message: "成功", type: "success" });
          this.dialogVisible = false;
          this.esarchang();
        } else {
          return false;
        }
      });
    },
    DetailToEdit() {
      this.compile(this.rowData);
    },
    // 详情
    handleDetail(row) {
      this.modalVisible = "detail";
      this.rowData = { ...row };
    },
    // 删除
    deletes(e) {
      this.$confirm("是否要删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await getACCompanyDelAction({ id: e.id });
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message({ message: "删除成功", type: "success" });
          this.esarchang();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    guanbi(formRef) {
      this.$refs[formRef].resetFields();
    },
    //刷新
    shuaxin() {
      this.call_type_id = ''
      this.$refs.searchform.onready();
      this.$refs.searchform2.onready();
      this.esarchang(1);
      this.$message({ message: "刷新成功", type: "success" });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    async getMainData(
      params = { page: this.currentPage, pagesize: this.pagesize }
    ) {
      let res = await getACCompanyPageAction(params);
      if (res.code !== 200) return this.$message.error(res.message);
      this.tableData = res.data.data || [];
      this.total = res.data.total || 0;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    // 分页
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.esarchang();
    },
  },
};
</script>
<style scoped lang="less" src="@/assets/css/especially.less"></style>
<style src="@/assets/css/index.css" scoped></style>
